// import gumlet from '@gumlet/insights-js-core'

export default function insightsInit (
  config,
  player,
  mediaElementRef,
  videoPlayerRef,
  starttime
) {
  if (!config || !config.property_id) {
    window.gumletInsights = null
    return
  }

  if (!window.gumlet) {
    console.error('Gumlet Insights not found')
    return
  }

  const gumletInsights = gumlet.insights(config)

  if (player === 'html5') {
    gumletInsights.registerHTML5Player(
      mediaElementRef,
      { starttime: window && window.firstLoadTime ? window.firstLoadTime : starttime }
    )
  } else if (player === 'shaka') {
    gumletInsights.registerShakaPlayer(
      videoPlayerRef,
      { starttime: window && window.firstLoadTime ? window.firstLoadTime : starttime, mediaElement: mediaElementRef }
    )
  } else if (player === 'hls') {
    gumletInsights.registerHLSJSPlayer(
      videoPlayerRef,
      { starttime: window && window.firstLoadTime ? window.firstLoadTime : starttime }
    )
  }
  window.gumletInsights = gumletInsights
}
